import React from 'react';

import { BAR_COLORS, type ProgressColor } from '../../theme/tokens';
import { Reveal } from '../Reveal/Reveal';
import { Skeleton } from '../Skeleton/Skeleton';
import { Track, Fill } from './ProgressBar.styles';

export type ProgressBarProps = {
  /** 0-100 target width. */
  value: number;
  color?: ProgressColor;
  /** Explicit fill colour, overriding the keyed `color` (e.g. a channel-health
   * accent resolved from CHANNEL_CARD_TONE). */
  barColor?: string;
  /** When false the bar stays empty (pre-mount state). */
  animate: boolean;
  /** Stagger offset in ms so a row of bars fills in sequence. */
  delay?: number;
  /** While true, the track shows a sheen placeholder instead of the fill (loading). */
  loading?: boolean;
  className?: string;
};

/** Thin pill progress bar that grows to `value`% on mount, staggered by `delay`. */
export const ProgressBar = ({ value, color = 'info', barColor, animate, delay = 0, loading = false, className }: ProgressBarProps): React.ReactElement => (
  <Track className={className}>
    <Reveal overlay loading={loading} placeholder={<Skeleton block width="100%" height="100%" radius={99} />}>
      <Fill $color={barColor ?? BAR_COLORS[color]} $width={animate ? value : 0} $delay={delay} />
    </Reveal>
  </Track>
);

export default ProgressBar;